import axios from 'axios'
var config = require('./config')

export const api = axios.create({
  baseURL: config.apiUrl,
  params: {
    token: localStorage.getItem('token')
  }
})



// WEBPACK FOOTER //
// ./src/components/http.js